import React from 'react';

export const lividVideoTag = 'livid-video';

export type LividVideoProps = {
  // Livid embed id, e.g. "xOk38XAEc1x9" from https://livid.com/embed/xOk38XAEc1x9
  id?: string;
  title?: string;
  // Height as a percentage of width (56.25 is 16:9)
  ratio?: string;
};

// Renders `<livid-video id="..." title="..." ratio="..."></livid-video>` from markdown.
// Markdown wraps the tag in a <p>, so this uses spans (an iframe is valid inside a span, a div is not).
export const LividVideo = ({ id, title, ratio = '56.25' }: LividVideoProps) => {
  if (!id) {
    console.warn('livid-video is missing an id');
    return null;
  }

  return (
    <span className="block relative w-full" style={{ paddingTop: `${ratio}%` }}>
      <iframe
        className="absolute inset-0 w-full h-full"
        // override the `.markdown iframe` margin, which would push the video out of its box
        style={{ margin: 0 }}
        src={`https://livid.com/embed/${encodeURIComponent(id)}`}
        title={title}
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture; web-share"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </span>
  );
};
